import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, FileDown, Loader2 } from "lucide-react";
import { api, BACKEND_URL } from "../lib/api";
import { money } from "../lib/market";

export default function RegistryGiftSuccess() {
  const { slug } = useParams();
  const [sp] = useSearchParams();
  const sid = sp.get("session_id");
  const [o, setO] = useState(null);
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid || o?.status === "paid" || tries > 15) return undefined;
    const t = setTimeout(() => api.get(`/public/registry/orders/${sid}`).then((r) => setO(r.data)).catch(() => {}).finally(() => setTries((n) => n + 1)), tries ? 2000 : 0);
    return () => clearTimeout(t);
  }, [sid, o, tries]);
  const paid = o?.status === "paid";
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6">
      <div className="bg-white border border-[var(--line)] rounded-3xl p-10 max-w-md w-full text-center" data-testid="registry-gift-status">
        {paid ? <CheckCircle2 className="w-12 h-12 text-[var(--gold)] mx-auto" /> : <Loader2 className="w-12 h-12 text-[var(--gold)] mx-auto animate-spin" />}
        <p className="font-serif text-3xl mt-4" data-testid="registry-gift-title">{paid ? "Thank you!" : tries > 15 ? "Still confirming…" : "Confirming your gift…"}</p>
        {o && <p className="text-[var(--muted)] mt-2">{o.items.map((i) => `${i.name} ${money(i.amount)}`).join(" · ")}</p>}
        {paid && <p className="text-sm mt-4">{o.couple_names || "The couple"} just got your gift. Your receipt is on its way to your inbox.</p>}
        <div className="flex flex-wrap gap-2 justify-center mt-6">
          {paid && o.invoice && <a href={`${BACKEND_URL}${o.invoice.pdf_url}`} target="_blank" rel="noreferrer" className="btn-gold !py-2.5" data-testid="registry-gift-invoice"><FileDown className="w-4 h-4" /> Invoice {o.invoice.number}</a>}
          <Link to="/account/orders" className="btn-outline-gold !py-2.5" data-testid="registry-gift-orders">Track my gifts</Link>
          <Link to={`/site/${slug}`} className="btn-outline-gold !py-2.5" data-testid="registry-gift-back">Back to the website</Link>
        </div>
      </div>
    </div>
  );
}
